var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tx-pair-wrapper" }, [
    _c(
      "span",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.symbol && _vm.realPrice,
            expression: "symbol && realPrice"
          }
        ],
        staticClass: "real-price",
        style: "top: " + _vm.top + "px"
      },
      [_vm._v(_vm._s(_vm.realPrice))]
    ),
    _vm._v(" "),
    _c(
      "div",
      { ref: "txList", staticClass: "tx-list" },
      _vm._l(_vm.showList, function(txPair, i) {
        return _c(
          "div",
          {
            key: i,
            ref: "txPair" + i,
            refInFor: true,
            staticClass: "__center-tb-row __pointer",
            class: { active: txPair && txPair.symbol === _vm.activeSymbol },
            on: {
              mouseenter: function($event) {
                return _vm.showRealPrice(txPair, i)
              },
              mouseleave: function($event) {
                return _vm.hideRealPrice(txPair)
              },
              click: function($event) {
                return _vm.setActiveTxPair(txPair)
              }
            }
          },
          [
            _c("span", { staticClass: "__center-tb-item tx-pair" }, [
              _c("span", {
                staticClass: "favorite-icon",
                class: { active: !!_vm.favoritePairs[txPair.symbol] },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.setFavorite(txPair)
                  }
                }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "describe" }, [
                _c("span", { staticClass: "des-text __ellipsis" }, [
                  _vm._v(_vm._s(_vm.getTxPairShowSymbol(txPair)))
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "mining-icon" }, [
                  _c("img", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isMining(txPair) === 1,
                        expression: "isMining(txPair) === 1"
                      }
                    ],
                    attrs: { src: require("assets/imgs/trade_mining.svg") }
                  }),
                  _vm._v(" "),
                  _c("img", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isMining(txPair) === 2,
                        expression: "isMining(txPair) === 2"
                      }
                    ],
                    attrs: { src: require("assets/imgs/order_mining.svg") }
                  }),
                  _vm._v(" "),
                  _c("img", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isMining(txPair) === 3,
                        expression: "isMining(txPair) === 3"
                      }
                    ],
                    attrs: { src: require("assets/imgs/mining.svg") }
                  }),
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.miningMultiples(txPair)) +
                      "\n                    "
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "__center-tb-item" }, [
              _c("img", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isZeroFee(txPair),
                    expression: "isZeroFee(txPair)"
                  }
                ],
                staticClass: "zero-fee-icon",
                attrs: { src: require("assets/imgs/trade/zero_fee.svg") }
              }),
              _vm._v(
                "\n                " +
                  _vm._s(
                    txPair.closePrice
                      ? _vm.formatNum(txPair.closePrice, txPair.pricePrecision)
                      : "--"
                  ) +
                  "\n            "
              )
            ]),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showCol === "updown",
                    expression: "showCol === 'updown'"
                  }
                ],
                staticClass: "__center-tb-item percent",
                class: {
                  up: +txPair.priceChange > 0,
                  down: +txPair.priceChange < 0
                }
              },
              [
                _vm._v(
                  _vm._s(
                    txPair.priceChangePercent
                      ? _vm.getPercent(txPair.priceChangePercent)
                      : "0.00%"
                  )
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showCol === "txNum",
                    expression: "showCol === 'txNum'"
                  }
                ],
                staticClass: "__center-tb-item"
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(
                      txPair.amount
                        ? _vm.formatNum(txPair.amount, _vm.transLimit)
                        : "0.0"
                    ) +
                    "\n            "
                )
              ]
            )
          ]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }